module.exports = __webpack_public_path__ + "img/Secondary-chevron-darker-blue.2a950ccd.svg";